import { z } from 'zod';
import { paginationQuerySchema, uuidSchema } from './common.js';
import { relatedEntitySchema, type BusinessManagerRef } from './records.js';

export const createNoteSchema = z.object({
  body: z.string().trim().min(1, 'Write something').max(20_000),
  isPinned: z.coerce.boolean().optional(),
  related: relatedEntitySchema,
});
export type CreateNoteInput = z.infer<typeof createNoteSchema>;

export const updateNoteSchema = z.object({
  body: z.string().trim().min(1).max(20_000).optional(),
  isPinned: z.coerce.boolean().optional(),
});
export type UpdateNoteInput = z.infer<typeof updateNoteSchema>;

export const listNotesQuerySchema = paginationQuerySchema.extend({
  leadId: uuidSchema.optional(),
  accountId: uuidSchema.optional(),
  contactId: uuidSchema.optional(),
  dealId: uuidSchema.optional(),
});
export type ListNotesQuery = z.infer<typeof listNotesQuerySchema>;

export interface NoteSummary {
  id: string;
  body: string;
  isPinned: boolean;
  businessManager: BusinessManagerRef | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * A record's activity feed: notes and activities interleaved in one
 * chronological stream, which is how a rep actually reads a record's history.
 */
export type TimelineEntry =
  | { kind: 'note'; at: string; note: NoteSummary }
  | {
      kind: 'activity';
      at: string;
      activity: {
        id: string;
        type: string;
        subject: string;
        status: string;
        businessManager: BusinessManagerRef | null;
      };
    }
  | {
      kind: 'stage_change';
      at: string;
      change: { from: string | null; to: string; by: string | null };
    }
  | { kind: 'created'; at: string; by: string | null };
